import React, { Component } from "react";
import DateDropdown from "../FieldsComponents/DateDropdown/DateDropdown";
import moment from "moment";

//import "./filterStyles.css";

const customStyles = {
  control: (provided, state) => ({
    // none of react-select's styles are passed to <Control />
    ...provided,
    width: "100%",
    borderWidth: "1px",
    borderRadius: "5px"
  }),
  menu: base => ({
    ...base,
    zIndex: 100
  })
};

class GridDateFilters extends Component {
  state = {
    tgtFieldName: ""
  };

  getValue = fieldName => {
    let value = this.props.value[fieldName];
    if (!value || value === undefined || value === "") {
      value = moment().format("DD-MM-YYYY");
    }
    return value;
  };

  handleChange = (newValue, key, isPayload) => {
    let fieldList = this.props.ogTableDef[this.props.path];
    let tgtFieldName = "";
    let tgtFieldFormat = "";
    let dateFieldKey = "";
    let applyDateFilters = false;
    Object.keys(fieldList).map(key => {
      let fieldDefs = fieldList[key];

      if (
        fieldDefs &&
        this.props.filtersList.includes(key) &&
        fieldDefs.type === "calendar"
      ) {
        dateFieldKey = key;
        tgtFieldName = key;
        tgtFieldFormat = fieldDefs.dateFormatOut;
      }
      applyDateFilters = true;
    });

    let newFilterVal = { ...this.props.value };
    if (newValue && newValue !== undefined) {
      newFilterVal[key] = newValue;
      newFilterVal["tgtDateField"] = tgtFieldName;
      newFilterVal["tgtDateFormat"] = tgtFieldFormat;
      this.props.stateHandler(newFilterVal, "searchDateFilters", false);
    }
  };

  getFiterFields = () => {
    let fieldList = this.props.ogTableDef[this.props.path];
    //console.log("path is: " + this.props.path);
    //console.log("field list " + JSON.stringify(fieldList));
    if (fieldList && fieldList !== undefined) {
      let tgtFieldName = "";
      let tgtFieldFormat = "";
      let dateFieldKey = "";
      let applyDateFilters = false;
      Object.keys(fieldList).map(key => {
        let fieldDefs = fieldList[key];
        if (
          fieldDefs &&
          this.props.filtersList.includes(key) &&
          fieldDefs.type === "calendar"
        ) {
          dateFieldKey = key;
          tgtFieldName = key;
          tgtFieldFormat = fieldDefs.dateFormatOut;
          applyDateFilters = true;
        }
      });
      if (applyDateFilters) {
        return (
          <tr>
            <td
              style={{
                borderColor: "black",
                borderStyle: "solid",
                borderWidth: "0px",
                padding: "0px"
              }}
            >
              <DateDropdown
                title={"FROM"}
                maxDetail="hour"
                format={"dd-MM-yyyy"}
                formatOut={"DD-MM-YYYY"}
                onChange={this.handleChange}
                fieldName={"FromDate"}
                value={this.getValue("FromDate")}
              />
            </td>
            <td
              style={{
                borderColor: "black",
                borderStyle: "solid",
                borderWidth: "0px",
                padding: "0px"
              }}
            >
              <DateDropdown
                title={"TO"}
                maxDetail="hour"
                format={"dd-MM-yyyy"}
                formatOut={"DD-MM-YYYY"}
                onChange={this.handleChange}
                fieldName={"ToDate"}
                value={this.getValue("ToDate")}
              />
            </td>
          </tr>
        );
      }
    }
  };

  render() {
    return (
      <div>
        <table
          style={{
            width: "100%",
            padding: "0px",
            margin: "0px",
            padding: "0px",
            tableLayout: "fixed",
            marginTop: "2px"
          }}
          className="table table-sm"
        >
          <tbody>{this.getFiterFields()}</tbody>
        </table>
      </div>
    );
  }
}

export default GridDateFilters;



// WEBPACK FOOTER //
// ./src/app/components/Screens/ContentGrid/GridDateFilters.jsx